<template>
  <tr>
    <td v-if="index === 0" :rowspan="rowspan">
      {{ item.projectName }}
    </td>
    <td>{{ item.name }}</td>
    <td>{{ item.mailAddress }}</td>
    <td>
      <Button
        variant="attention"
        fsize="f12"
        block
        :disabled="isDisabled"
        @click="deleteUser"
      >
        削除する
      </Button>
    </td>
  </tr>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    rowspan: {
      type: Number,
      required: true
    }
  },
  components: {
    Button
  },
  computed: {
    hasOrganizations() {
      return this.$store.getters['user/hasOrganizations'];
    },
    isDisabled() {
      return this.item.isDelegate || this.hasOrganizations;
    }
  },
  methods: {
    deleteUser() {
      if (this.isDisabled) {
        return;
      }
      this.$emit('delete', this.item);
    }
  }
};
</script>
